"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalOverlay = exports.Modal = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_aria_components_1 = require("react-aria-components");
var theme_1 = require("../theme");
/**
 * A modal wrapper for dialogs that appear on top of the main content.
 * It provides a way to present content in a focused way, requiring user interaction to dismiss.
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/Modal.html}
 * @see {@link https://compass.circleci.com/?path=/story/rac-modal--default}
 *
 * @example
 * ```tsx
 * <Modal>
 *   <ModalOverlay>
 *     <Dialog>
 *       // Dialog content
 *     </Dialog>
 *   </ModalOverlay>
 * </Modal>
 * ```
 *
 * @param isEntering - Whether the modal is currently performing an entry animation
 * @param isExiting - Whether the modal is currently performing an exit animation
 * @param isDismissable - Whether to close the modal when the user interacts outside it. Defaults to false
 * @param isKeyboardDismissDisabled - Whether pressing the escape key to close the modal should be disabled. Defaults to false
 * @param shouldCloseOnInteractOutside - When user interacts with the argument element outside of the overlay ref, return true if onClose should be called
 * @param isOpen - Whether the overlay is open by default (controlled)
 * @param defaultOpen - Whether the overlay is open by default (uncontrolled)
 * @param children - The children of the component. Can be ReactNode or a render function
 * @param className - The CSS className for the element. Can be string or a function
 * @param style - The CSS styles for the element. Can be CSSProperties or a function
 * @param onOpenChange - Handler that is called when the overlay's open state changes
 */
exports.Modal = (0, styled_1.default)(react_aria_components_1.Modal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-shadow: 0px 0px 8px 0px rgba(13, 20, 35, 0.12);\n  border-radius: ", ";\n  outline: none;\n"], ["\n  box-shadow: 0px 0px 8px 0px rgba(13, 20, 35, 0.12);\n  border-radius: ", ";\n  outline: none;\n"])), theme_1.theme.radii.card);
/**
 * An overlay that appears behind the modal dialog.
 * It provides a semi-transparent backdrop that helps focus attention on the modal content.
 *
 * @example
 * ```tsx
 * <ModalOverlay>
 *   <Dialog>
 *     // Dialog content
 *   </Dialog>
 * </ModalOverlay>
 * ```
 *
 * @param children - The modal content to display
 * @param className - The CSS className for the element
 * @param style - The CSS styles for the element
 */
exports.ModalOverlay = (0, styled_1.default)(react_aria_components_1.ModalOverlay)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: var(--visual-viewport-height);\n  z-index: 100;\n  background: rgba(", ", ", ");\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: var(--visual-viewport-height);\n  z-index: 100;\n  background: rgba(", ", ", ");\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), theme_1.theme.colors.bgScrimDark, theme_1.theme.opacity.overlay);
var templateObject_1, templateObject_2;
//# sourceMappingURL=Modal.js.map